module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-printer-wrap"
  }, [(!_vm.list.length) ? _c('div', {
    staticClass: "empty-holder"
  }, [_vm._v("暂无用户操作")]) : _vm._e(), _vm._v(" "), _c('ul', {
    ref: "textprinter",
    staticClass: "text-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('bs-chart-printer-item', {
      key: item.key,
      attrs: {
        "text": item.text,
        "time": item.time
      },
      on: {
        "printFinished": _vm.delayAddItem
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-596719d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/text-printer/index.vue
// module id = 237
// module chunks = 0